import React from 'react';
import RelatedEmails from 'components/RelatedEmails';

/**
 * Proje e-posta sayfası
 * Tüm fonksiyonalite RelatedEmails componentine taşındı
 *
 * @param {Object} props - Component props
 * @param {Object} props.project - Proje verisi
 * @returns {JSX.Element}
 */
const EmailPage = ({ project }) => {
    return <RelatedEmails entity={project} entityType="project" title="Proje E-postaları" />;
};

export default EmailPage;
